import { render, staticRenderFns } from "./modal-cookie-main.vue?vue&type=template&id=277d1dc9&scoped=true&"
import script from "./modal-cookie-main.vue?vue&type=script&lang=js&"
export * from "./modal-cookie-main.vue?vue&type=script&lang=js&"
import style0 from "./modal-cookie-main.vue?vue&type=style&index=0&id=277d1dc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d1dc9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default})
